import axios from 'axios'
import authHeader from './auth-header'

class DocuSignService {

  getDocumentByEnvolopeId ( envelopeId ) {
      return axios.get(process.env.VUE_APP_API_URL + `docusign/envelopes/${ envelopeId }/signed-term`, { headers: authHeader() })
    }

  getVerificaContrato ( envelopeId ) {
      return axios.get(process.env.VUE_APP_API_URL + `docusign/envelopes/${ envelopeId }`, { headers: authHeader() })
    }
      
}

export default new DocuSignService()